import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Json, PaginatedResponse } from 'src/app/_shared/interface/common.interface';

@Injectable({
  providedIn: 'root',
})
export class FollowedPropertiesState {
  private openCreateWatchListSheetSub$ = new BehaviorSubject<boolean>(false);
  openCreateWatchListSheet$ = this.openCreateWatchListSheetSub$.asObservable();
  public get openCreateWatchListSheetValue(): boolean {
    return this.openCreateWatchListSheetSub$.value;
  }
  public set openCreateWatchListSheetValue(status: boolean) {
    this.openCreateWatchListSheetSub$.next(status);
  }

  private activeFavoriteGroupSub$ = new BehaviorSubject<Json>(null);
  activeFavoriteGroup$ = this.activeFavoriteGroupSub$.asObservable();
  public get activeFavoriteGroupValue(): Json {
    return this.activeFavoriteGroupSub$.value;
  }
  public set activeFavoriteGroupValue(value: Json) {
    this.activeFavoriteGroupSub$.next(value);
  }

  private favoritePropertiesByGroupSub$ = new BehaviorSubject<PaginatedResponse>({
    data: null,
    totalCount: 0,
  });
  favoritePropertiesByGroup$ = this.favoritePropertiesByGroupSub$.asObservable();
  public get favoritePropertiesByGroupValue(): PaginatedResponse {
    return this.favoritePropertiesByGroupSub$.value;
  }
  public set favoritePropertiesByGroupValue(value: PaginatedResponse) {
    this.favoritePropertiesByGroupSub$.next(value);
  }
}
